export const popularCompanies = [
  {
    id: 'netflix',
    name: 'Netflix',
    logo: 'https://logo.clearbit.com/netflix.com',
    category: 'Entertainment'
  },
  {
    id: 'amazon-prime',
    name: 'Amazon Prime',
    logo: 'https://logo.clearbit.com/amazon.com',
    category: 'Shopping'
  },
  {
    id: 'spotify',
    name: 'Spotify',
    logo: 'https://logo.clearbit.com/spotify.com',
    category: 'Music'
  },
  {
    id: 'godaddy',
    name: 'GoDaddy',
    logo: 'https://logo.clearbit.com/godaddy.com',
    category: 'Hosting'
  },
  {
    id: 'adobe',
    name: 'Adobe Creative Cloud',
    logo: 'https://logo.clearbit.com/adobe.com',
    category: 'Software'
  },
  {
    id: 'namecheap',
    name: 'Namecheap',
    logo: 'https://logo.clearbit.com/namecheap.com',
    category: 'Domains'
  },
  {
    id: 'icloud',
    name: 'Apple iCloud',
    logo: 'https://logo.clearbit.com/icloud.com',
    category: 'Storage'
  },
  {
    id: 'hulu',
    name: 'Hulu',
    logo: 'https://logo.clearbit.com/hulu.com',
    category: 'Entertainment'
  }
]; 